"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BoxedButtonBase } from "./ButtonBase.js";
import { getButtonVariantProps } from "./createButtonVariant.js";
const SuccessButton = forwardRef(function SuccessButton2(props, ref) {
  return jsx(BoxedButtonBase, { ref, ...getButtonVariantProps("success", props) });
});
export {
  SuccessButton
};
